import { useQuery } from "@tanstack/react-query";
import { api } from "../api";

export default function Dashboard() {
  const { data, isLoading } = useQuery({ queryKey: ["admin-stats"], queryFn: async () => (await api.get("/admin/stats")).data });
  if (isLoading) return <p className="veri">Yükleniyor…</p>;
  const s = data || {};
  return (
    <div>
      <h1 style={{ fontFamily: "var(--display)", fontSize: 26, marginBottom: 20 }}>Gösterge</h1>
      <div className="a-kartlar">
        <div className="a-kart"><div className="veri">Toplam lead</div><b>{s.total_leads}</b></div>
        <div className="a-kart"><div className="veri">Dönüşüm oranı</div><b>%{s.conversion}</b></div>
        <div className="a-kart"><div className="veri">Müsait daire</div><b>{s.musait}</b></div>
        <div className="a-kart"><div className="veri">Satılan daire</div><b>{s.satildi}</b></div>
        <div className="a-kart"><div className="veri">Opsiyonlu</div><b>{s.opsiyonlu}</b></div>
      </div>

      <div className="a-satir" style={{ gap: 28, alignItems: "flex-start", flexWrap: "wrap" }}>
        <div style={{ flex: 1, minWidth: 320 }}>
          <h3 className="veri" style={{ marginBottom: 10 }}>Son 10 lead</h3>
          <table className="a-tablo">
            <thead><tr><th>Ad</th><th>Telefon</th><th>Kaynak</th><th>Durum</th></tr></thead>
            <tbody>{(s.recent_leads || []).map((l) => (<tr key={l.id}><td>{l.ad}</td><td className="sayi">{l.telefon}</td><td>{l.kaynak}</td><td>{l.durum}</td></tr>))}</tbody>
          </table>
        </div>
        <div style={{ flex: 1, minWidth: 320 }}>
          <h3 className="veri" style={{ marginBottom: 10 }}>Yaklaşan randevular</h3>
          <table className="a-tablo">
            <thead><tr><th>Tarih</th><th>Saat</th><th>Proje</th><th>Ad</th></tr></thead>
            <tbody>{(s.upcoming || []).length === 0 ? <tr><td colSpan={4} className="veri">Randevu yok</td></tr> : (s.upcoming || []).map((a) => (<tr key={a.id}><td className="sayi">{a.tarih}</td><td className="sayi">{a.saat}</td><td>{a.proje}</td><td>{a.ad}</td></tr>))}</tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
